const DEFAULT_BUCKET = "w-treasure.appspot.com";

/**
 * Turn a Firestore storage path or broken API URL into a usable download URL.
 * Production used to emit `undefinedcategory%2F...` when FIREBASE_STORAGE was unset.
 */
export function resolveStorageUrl(value) {
  if (!value || typeof value !== "string") return "";

  let v = value.trim();
  if (v.startsWith("undefined")) {
    v = v.slice("undefined".length);
  }
  if (!v) return "";

  if (/^https?:\/\//i.test(v)) {
    return v;
  }

  const pathOnly = v.replace(/\?alt=media$/i, "");
  let storagePath = pathOnly;
  try {
    if (pathOnly.includes("%")) {
      storagePath = decodeURIComponent(pathOnly);
    }
  } catch {
    storagePath = pathOnly;
  }

  return `https://firebasestorage.googleapis.com/v0/b/${DEFAULT_BUCKET}/o/${encodeURIComponent(
    storagePath
  )}?alt=media`;
}
